import { tv } from 'tailwind-variants';

const styles = tv({
    base: `
    iris:w-full 
    iris:px-(--base-space-px-4) 
    iris:py-(--base-space-px-2)
  `,
    variants: {
        xsColSpan: {
            1: "iris:col-span-1",
            2: "iris:col-span-2",
            3: "iris:col-span-3",
            4: "iris:col-span-4",
            5: "iris:col-span-5",
            6: "iris:col-span-6",
            7: "iris:col-span-7",
            8: "iris:col-span-8",
            9: "iris:col-span-9",
            10: "iris:col-span-10",
            11: "iris:col-span-11",
            12: "iris:col-span-12",
        },
        smColSpan: {
            1: "iris:sm:col-span-1",
            2: "iris:sm:col-span-2",
            3: "iris:sm:col-span-3",
            4: "iris:sm:col-span-4",
            5: "iris:sm:col-span-5",
            6: "iris:sm:col-span-6",
            7: "iris:sm:col-span-7",
            8: "iris:sm:col-span-8",
            9: "iris:sm:col-span-9",
            10: "iris:sm:col-span-10",
            11: "iris:sm:col-span-11",
            12: "iris:sm:col-span-12",
        },
        mdColSpan: {
            1: "iris:md:col-span-1",
            2: "iris:md:col-span-2",
            3: "iris:md:col-span-3",
            4: "iris:md:col-span-4",
            5: "iris:md:col-span-5",
            6: "iris:md:col-span-6",
            7: "iris:md:col-span-7",
            8: "iris:md:col-span-8",
            9: "iris:md:col-span-9",
            10: "iris:md:col-span-10",
            11: "iris:md:col-span-11",
            12: "iris:md:col-span-12",
        },
        lgColSpan: {
            1: "iris:lg:col-span-1",
            2: "iris:lg:col-span-2",
            3: "iris:lg:col-span-3",
            4: "iris:lg:col-span-4",
            5: "iris:lg:col-span-5",
            6: "iris:lg:col-span-6",
            7: "iris:lg:col-span-7",
            8: "iris:lg:col-span-8",
            9: "iris:lg:col-span-9",
            10: "iris:lg:col-span-10",
            11: "iris:lg:col-span-11",
            12: "iris:lg:col-span-12",
        },
        xsRowSpan: {
            1: "iris:row-span-1",
            2: "iris:row-span-2",
            3: "iris:row-span-3",
            4: "iris:row-span-4",
            5: "iris:row-span-5",
            6: "iris:row-span-6",
        },
        smRowSpan: {
            1: "iris:sm:row-span-1",
            2: "iris:sm:row-span-2",
            3: "iris:sm:row-span-3",
            4: "iris:sm:row-span-4",
            5: "iris:sm:row-span-5",
            6: "iris:sm:row-span-6",
        },
        mdRowSpan: {
            1: "iris:md:row-span-1",
            2: "iris:md:row-span-2",
            3: "iris:md:row-span-3",
            4: "iris:md:row-span-4",
            5: "iris:md:row-span-5",
            6: "iris:md:row-span-6",
        },
        lgRowSpan: {
            1: "iris:lg:row-span-1",
            2: "iris:lg:row-span-2",
            3: "iris:lg:row-span-3",
            4: "iris:lg:row-span-4",
            5: "iris:lg:row-span-5",
            6: "iris:lg:row-span-6",
        },
    },
});

export { styles as default };
